/**
 * Storage full: QuotaExceededError (IndexedDB, localStorage) or SQLITE_FULL
 * (Android AsyncStorage).
 */
export function isQuotaError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const e = error as { name?: string; code?: number; message?: string };
  return (
    e.name === "QuotaExceededError" ||
    e.name === "NS_ERROR_DOM_QUOTA_REACHED" ||
    e.code === 22 ||
    e.code === 1014 ||
    /quota|SQLITE_FULL|disk is full/i.test(e.message ?? "")
  );
}
